import React, {Component} from 'react';
import '../../pages/settingsPage/SettingsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import CheckBox from '../../inputs/checkBox/CheckBox';
import models from '../../model/models';
import userGroupSettingsManager from '../../utils/UserGroupSettingsManager';
import BloodCommUuidCard from "../../cards/bloodCommUuidCard/BloodCommUuidCard";
import SettingsTabBar from '../../components/settingsTabBar/SettingsTabBar';
import toasts from '../../utils/toasts';
import {SettingRow} from '../settingsPage/SettingsPage';

export default class BloodCommSettingsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user_group: {},
		};
	}

	componentDidMount = async () => {
		this.subscribeId = models.user_group.onChange(this._getData);

		await this._getData();
	};

	componentWillUnmount = () => {
		if (this.subscribeId) {
			models.user_group.unsubscribe(this.subscribeId);
		}
	};

	_getData = async () => {
		let user_group = models.user_group.obj();
		if (!user_group) return;
		await userGroupSettingsManager.refresh(user_group.id);
		this.setState({user_group});
	};

	toggleSensors = async (value) => {
		value = value ? 1 : 0;
		const {user_group: {id: user_group_id} = {}} = this.state;
		try {
			await userGroupSettingsManager.upsert({name: 'allow_temperature_sensor', value, user_group_id});
			await this._getData();
			toasts.show(`Integration ${value ? 'enabled' : 'disabled'}`);
		} catch (e) {
			toasts.show('Failed to update Sensors');
		}
	};

	render() {
		const allow_temperature_sensor = userGroupSettingsManager.getSetting('allow_temperature_sensor');
		return (
			<Page className="g-settings-page">
				<Card>
					<Label larger black>
						Account settings
					</Label>
					<div className="lower">
						<SettingsTabBar userGroup={this.state.user_group}/>

						<BloodCommUuidCard hideContent={!allow_temperature_sensor}>
							<br/>
							<SettingRow>
								<CheckBox forceValue={Boolean(allow_temperature_sensor)} onChange={this.toggleSensors}/>
								<Label gray-dark>Enable BloodComm Integration</Label>
							</SettingRow>
						</BloodCommUuidCard>
					</div>
				</Card>
			</Page>
		);
	}
}




// WEBPACK FOOTER //
// ./src/pages/bloodCommSettingsPage/BloodCommSettingsPage.jsx